import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Trophy } from "lucide-react";
import { API } from "@/lib/api";
import Scoreboard from "@/components/Scoreboard";
import Reveal from "@/components/Reveal";

const Cronicas = () => {
  const [cronicas, setCronicas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get("/articles", { params: { category: "cronica", limit: 50 } })
      .then(({ data }) => setCronicas(data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-ink pt-32">
      <div className="mx-auto max-w-5xl px-5 pb-24 md:px-12">
        <Reveal>
          <p className="eyebrow mb-3">Minuto a minuto, desde la grada</p>
          <h1 className="font-display text-4xl font-black uppercase tracking-tight text-white sm:text-6xl">
            Crónicas de partidos
          </h1>
          <p className="mt-4 max-w-2xl text-slate-300">
            Cada partido del Sporting de Gijón contado como se vive: con tensión, sufrimiento
            y alguna que otra noche mágica en El Molinón.
          </p>
        </Reveal>

        <div className="mt-12 space-y-8" data-testid="cronicas-list">
          {loading &&
            [...Array(2)].map((_, i) => (
              <div key={i} className="h-44 animate-pulse rounded-2xl border border-edge bg-ink2" />
            ))}
          {!loading && cronicas.length === 0 && (
            <div className="flex flex-col items-center gap-3 py-24 text-center">
              <Trophy className="h-10 w-10 text-slate-600" />
              <p className="text-slate-400">Aún no hay crónicas publicadas. ¡Vuelve tras el próximo partido!</p>
            </div>
          )}
          {cronicas.map((c, i) => (
            <Reveal key={c.slug} delay={Math.min(i * 0.07, 0.3)}>
              <Link to={`/articulo/${c.slug}`} data-testid={`cronica-card-${c.slug}`} className="group block">
                <div className="transition-transform duration-300 group-hover:scale-[1.01]">
                  <Scoreboard match={c} />
                </div>
                <div className="mt-4 flex items-center justify-between gap-4">
                  <h2 className="font-display text-xl font-bold uppercase leading-tight text-white sm:text-2xl">
                    {c.title}
                  </h2>
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-edge text-slate-400 transition-colors group-hover:border-crimson group-hover:bg-crimson group-hover:text-white">
                    <ArrowRight className="h-4 w-4" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Cronicas;
